class NmcsState {
  /** final update after all actions did run */
  finalUpdate(_action) {
  }
}
export {
  NmcsState
};
//# sourceMappingURL=index134.js.map
